import React, { useState } from 'react';
import Credits from './components/Credits';

import Imatge from './components/Imatge';
import Map from './components/Map';
import Portada from './components/Portada';
import Sidebar from './components/Sidebar';
import Text from './components/Text';

import categoriesData from './data/categories';

const App = () => {
  const [mapbox, setMapbox] = useState();
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [nodes] = useState(categoriesData);
  const [siteTitleInverse, setSiteTitleInverse] = useState('');

  window.addEventListener('scroll', () => {
    const block = document.getElementById('block-imatge');
    if (block.getBoundingClientRect().top - window.innerHeight / 2 < 0) {
      setSiteTitleInverse('site-title__inverse');
    } else {
      setSiteTitleInverse('');
    }
  });

  return (
    <div className="site">
      <div className={`site-title ${siteTitleInverse}`}>Sarrià:Ecosistema</div>
      <div className="site-prototip">Prototip</div>
      <Portada />
      <Text />
      <Imatge />

      <section
        className="block block-mapa"
        id="block-mapa">
        <div className="map-container">
          <Map setMapbox={setMapbox} />
        </div>
        <Sidebar
          mapbox={mapbox}
          nodes={nodes}
          checked={checked}
          setChecked={setChecked}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      </section>

      <Credits />
    </div>
  );
};

export default App;
